import { ElementDetails } from "@/lib/types";
import { TrelloAssignmentsProps } from "./types";

export const details = {
  name: "TrelloAssignments",
  description: "Displays your Trello assignments.",
  tags: ["Business", "Productivity", "Organization"],
  category: "Trello",
  grid: { default: [3, 3], large: [4, 4] },
  gridNames: {
    default: "Medium",
    large: "Large",
  },
  integrationsUsed: ["trello"],
  defaultProps: {
    organization: null,
    board: null,
    filteredLists: [],
    assignedToMe: true,
    dueDate: "none",
  },
} as ElementDetails<TrelloAssignmentsProps>;
